export default "__VITE_ASSET__DxMncdtY__"